//Style
import '../../styles/responsivephone/phone_projects.scss'
import '../../styles/responsivephone/phone_notes.scss'

//Images
import Note1 from '../../assets/note_1_img.jpg'
import Note2 from '../../assets/note_2_img.jpg'
import Note3 from '../../assets/note_3_img.jpg'

//Components
import ErrorPhone from "../../components/error/error_phone_version"
import PhoneHeader from "../../components/phoneresponsive/phone_header"
import Note from '../../components/main/note'
import PhoneFooter from '../../components/phoneresponsive/phone_footer'

//Language
import { useLanguage } from '../../context/language_context'


function NotesPhone() {

    const { language } = useLanguage()

    return (
        <div className="phone_projects">

            <ErrorPhone />

            <PhoneHeader />

            <p className='phone_projects_title'>
                {language === 'fr'
                    ? 'Mes notes'
                    : 'My notes'}
            </p>

            <div className='phone_notes_container'>

                <Note
                    text={
                        language === 'fr'
                            ? 'To do : Finir le portfolio !'
                            : 'To do: Finish the portfolio!'
                    }
                    img={Note1}
                    className='note_1'
                />

                <Note
                    text={
                        language === 'fr'
                            ? 'Halloween 2026 en approche !'
                            : 'Halloween 2026 is coming!'
                    }
                    img={Note2}
                    className='note_2'
                />

                <Note
                    text={
                        language === 'fr'
                            ? 'To do : Organiser une exposition avec les dessins de Moonloading !'
                            : 'To do: Organize an exhibition featuring the Moonloading illustrations!'
                    }
                    img={Note3}
                    className='note_3'
                />

            </div>

            <PhoneFooter />

        </div>
    )
}

export default NotesPhone